// extracted by mini-css-extract-plugin
export default {"root":"AppLayout_root__mfwox","sidebarWrapper":"AppLayout_sidebarWrapper__xA+qI","navbarAndContentWrapper":"AppLayout_navbarAndContentWrapper__JX20y"};